//CSS 
import "@/assets/css/appToolbar.scss";
// Constant 
import { ROUTE_URL } from "@/constant/route";
// Extend
import base from '@/scripts/base';

// Component
import QuickPackageStatus from "@/views/Package/QuickPackageStatus.vue";
import QuickNotification from "@/views/Notifications/QuickNotification.vue";


import Vue from "vue";
import { mapState } from "vuex";
import commonActionHandle from "@/commonActionHandle";
import authApi from "@/api/auth";

export default {

    extends: base,

    components: {
        QuickPackageStatus,
        QuickNotification,
    },

    data() {
        return {
            imgDict: {
                "1": "dot-green",
                "2": "dot-blue",
                "3": "dot-orange",
                "4": "dot-red"
            },
            colorDict: {
                "1": "#4CAF50",
                "2": "#2196F3",
                "3": "#E65100",
                "4": "#F44336"
            },
        };
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
            tempBalance: state => state.auth.tempBalance,
            gpuHubServicePack: state => state.common.gpuHubServicePack,
            cpuHubServicePack: state => state.common.cpuHubServicePack,
            remoteFarmServicePack: state => state.common.remoteFarmServicePack,
            availabilityServiceList: state => state.common.availabilityServiceList,
            countMachine: state => state.common.countMachine,

            serverReport: state => state.common.serverReport,
        }),

        temp() {
            return this.tempBalance;
        },

        profilePhoto() {
            return localStorage.getItem("profilePhoto");
        },
    },

    created() {
        this.currentUrl = this.$route.path;
    },

    methods: {
        collapseNav() {
            this.$emit("processingEvent", { event: "collapseNav" });
        },

        goQuickStart() {
            if (this.user.region === 'VN') {
                window.open('https://irender.vn/huong-dan-su-dung-chi-tiet-dich-vu-gpuhub/', '_blank');
            } else {
                window.open('https://docs.gpuhub.net/workflow/1-register/', '_blank');
            }
            this.matomoLog('HeaderBar', 'Click', 'Quick start');
        },

        goDocuments() {
            window.open('https://docs.gpuhub.net/', '_blank');
        },

        // Context menu action
        contextMenuAction(command) {
            switch (command) {
                case ROUTE_URL.CUSTOMER_INFORMATION:
                case ROUTE_URL.ACCOUNT_SECURITY:
                case ROUTE_URL.BILLING_HISTORY:
                case ROUTE_URL.AFFILIATE_PROGRAM:
                case ROUTE_URL.COUPONS:
                case ROUTE_URL.SETTINGS:
                case ROUTE_URL.USER_HISTORY:
                    this.pushUrl(command);
                    break;
                case "logout":
                    this.handleLogut();
                    this.matomoLog('HeaderBar_Menu', 'Click', 'Logout');
                    break;
            }
        },

        // Logout
        handleLogut() {
            commonActionHandle.showCustomConfirm(
                this.$lang.dialog.logoutTitle,
                this.$lang.dialog.logoutConfirm,
                () => {
                    if(window.chatTool ==="chatwood") window.$chatwoot.reset();
                    authApi
                        .logout({
                            deviceInformation: JSON.stringify(this.getInformationClient())
                        })
                        .then(res => {
                            localStorage.removeItem("profilePhoto");
                            localStorage.removeItem("user");
                            localStorage.removeItem("userId");
                            Vue.$cookies.remove(".iRenderGpuHub.Security.Identity");
                            Vue.$cookies.remove("IsShowImportantNews");
                        })
                        .catch(error => { });
                    setTimeout(() => {
                        if (this.$route.path !== "/login") {
                            location.href = "/login";
                        }
                    }, 500);
                }
            );
        },

        // Open pop-up
        openPopup(popup, value) {
            this.$emit("openPopup", popup, value);
        }
    },
};